import React, {useState, useEffect, useRef, useCallback} from "react";
import {TextField} from "@mui/material";

const DebouncedTextField = ({value, onChange, debounceMs = 500, ...props}) => {
  const [local, setLocal] = useState(value);
  const timerRef = useRef(null);

  useEffect(() => {
    setLocal(value);
  }, [value]);
  useEffect(() => () => clearTimeout(timerRef.current), []);

  const handleChange = useCallback(
    (e) => {
      const val = e.target.value;
      setLocal(val);
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => onChange(val), debounceMs);
    },
    [onChange, debounceMs],
  );

  return <TextField {...props} value={local} onChange={handleChange} />;
};

export default DebouncedTextField;
